import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { SxErrorService } from 'app/services/sx-error.service';
import { ServiceAgreement, ServiceAgreementInformation }from '@model';

@Injectable()

  export class ServiceAgreementService {

     constructor(private http: HttpClient, private sxErrorService: SxErrorService) {}
    
    getMyServiceAgreement(): Observable<ServiceAgreement[]> {
        return this.http
        .get<ServiceAgreement[]>(`${environment.apiEndpoint}/serviceagreements`)
        .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
    }

    createReportKey(): Observable<string> {
        return this.http
          .get<string>(`${environment.apiEndpoint}/serviceagreements/key`)
          .pipe(catchError((error: any) => throwError(() => new Error(error.json()))));
      }
    
    exportToExcel(key: string, serviceagreements: ServiceAgreementInformation[]): Observable<any> {
        return this.http
          .post<any>(`${environment.apiEndpoint}/reports/${key}/serviceagreements/export`, serviceagreements, {
            responseType: 'blob' as 'json'
          })
          .pipe(catchError((error: any) => this.sxErrorService.handleError(error)));
      }
  }